export const isImageFile = ({ type }) => /^image\//.test(type);
